<template>
  <div class="other">
    <drag-modal :visible="$store.state.dislog.Other" @cancel="reset" :title='info.id ? "修改其他债务人" : "添加其他债务人"'
      width='740px'>
      <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }"
        class="otherform">
        <a-form-model-item label="其他债务人姓名/名称" prop="realname">
          <a-input v-model="form.realname" :disabled='isEdit(info.audit, "realname") || see'
            :class='{ "yellow": isEdit(info.audit, "realname") }' />
        </a-form-model-item>
        <a-form-model-item label="债务人证件号码" prop="chinaid">
          <a-input v-model="form.chinaid" :maxLength="18" :disabled='isEdit(info.audit, "chinaid") || see'
            :class='{ "yellow": isEdit(info.audit, "chinaid") }' @blur="getSex(form.chinaid)" />
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="phone">
          <a-input v-model="form.phone" :maxLength="20" :disabled='isEdit(info.audit, "phone") || see'
            :class='{ "yellow": isEdit(info.audit, "phone") }' />
        </a-form-model-item>
        <a-form-model-item label="关系：" prop="relation">
          <a-select v-model="form.relation" placeholder="请选择" style="width:160px;"
            :class='{ "yellow": isEdit(info.audit, "relation") }' :disabled='isEdit(info.audit, "relation") || see'>
            <a-select-option :value="2">配偶</a-select-option>
            <a-select-option :value="3">反担保人-个人</a-select-option>
            <a-select-option :value="4">反担保人-企业</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="性别：" prop="sex" v-if='form.relation == 2 || form.relation == 3'>
          <a-select v-model="form.sex" placeholder="请选择" style="width:114px;"
            :class='{ "yellow": isEdit(info.audit, "sex") }' :disabled='isEdit(info.audit, "sex") || see'>
            <a-select-option :value="1">男</a-select-option>
            <a-select-option :value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="户籍所在地/企业地址：" prop="citys">
          <a-cascader :options="options" placeholder="请选择"
            :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='form.citys'
            :class='{ "yellow": isEdit(info.audit, "province,city,area") }'
            :disabled='isEdit(info.audit, "province,city,area") || see' @change="citysCg" />
          <a-input v-model="form.addr" type='textarea' style="margin-top:20px;" placeholder="请输入债务人详细地址"
            :class='{ "yellow": isEdit(info.audit, "addr") }' :disabled='isEdit(info.audit, "addr") || see'
            @blur="AddCg" />
        </a-form-model-item>
        <a-form-model-item label="经常居住地：" prop="dwell">
          <a-cascader :options="options" placeholder="请选择"
            :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='form.dwell'
            :disabled='isEdit(info.audit, "dwell_province,dwell_city,dwell_area") || see'
            :class='{ "yellow": isEdit(info.audit, "dwell_province,dwell_city,dwell_area") }' />
          <a-input v-model="form.dwell_addr" type='textarea' style="margin-top:20px;" placeholder="经常居住地详细地址"
            :disabled='isEdit(info.audit, "dwell_addr") || see'
            :class='{ "yellow": isEdit(info.audit, "dwell_addr") }' />
        </a-form-model-item>
        <a-form-model-item label="备注：" prop="comment">
          <a-input v-model="form.comment" type='textarea' placeholder="备注"
            :disabled='isEdit(info.audit, "comment") || see' :class='{ "yellow": isEdit(info.audit, "comment") }' />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }" v-if='!see'>
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='confirm(info.id)'>
            <a-button type="primary" style="width:148px;margin-right:20px;">
              提交
            </a-button>
          </a-popconfirm>
          <a-button style='background:#B2C9E1;color:#fff;width:148px;' @click='reset'>取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
  </div>
</template>
<script>
import city from "@/assets/js/city.json"
import Validator from "@/assets/js/yz.js"
import { debtorOther } from "@/server/debtor"
import { citySort } from '@/assets/js/unit'
export default {
  name: 'Other',
  props: {
    info: {
      type: Object,
      default() {
        return {
          audit: []
        }
      }
    }
  },
  data() {
    // 自定义验证函数
    const validateChinaId = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入债务人证件号码'));
        return;
      }

      // 身份证验证规则
      const idCardPattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      // 统一社会信用代码验证规则
      const creditCodePattern = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;

      // 检查是否符合身份证格式
      const isIdCard = idCardPattern.test(value);
      // 检查是否符合统一社会信用代码格式
      const isCreditCode = creditCodePattern.test(value);

      // 如果两种格式都不符合，返回错误
      if (!isIdCard && !isCreditCode) {
        callback(new Error('请输入有效的债务人证件号码'));
      } else {
        callback();
      }
    };
    return {
      options: citySort(city),
      visible: false,
      rules: {
        realname: [{ required: true, message: '请输入债务人姓名', trigger: 'blur' }],
        chinaid: [
          { required: true, trigger: 'blur', message: '请输入债务人证件号码' },
          { validator: validateChinaId, trigger: ['blur', 'change'] }
        ],  //validator: Validator.chinaid 
        phone: [{ required: true, trigger: 'blur', message: '请输入联系方式', }, { validator: Validator.validateContact, trigger: ['blur', 'change'] }],
        sex: [{ required: true, trigger: 'change', message: '请选择债务人性别' }],
        relation: [{ required: true, trigger: 'change', message: '请选择关系' }],
        citys: [{ required: true, trigger: 'change', message: '请选择户籍所在地' }]
      },
      see: false,
      form: {
        dwell_addr: '',
        realname: null,
        chinaid: null,
        phone: null,
        sex: 1,
        relation: null,
        citys: null,
        dwell: []
      }
    }
  },
  components: {

  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal.id) {
          this.form = {
            citys: [newVal.province, newVal.city, newVal.area],
            dwell: newVal.dwell_province ? [newVal.dwell_province, newVal.dwell_city, newVal.dwell_area] : [newVal.province, newVal.city, newVal.area],
            dwell_addr: newVal.dwell_addr,
            comment: newVal.comment,
            addr: newVal.addr,
            chinaid: newVal.chinaid,
            realname: newVal.realname,
            phone: newVal.phone,
            sex: newVal.sex,
            relation: newVal.relation
          }
          this.see = newVal.see
        } else {
          this.form = {
            citys: newVal.city || [],
            dwell: newVal.dwell || [],
            dwell_addr: newVal.dwell_addr || '',
            comment: newVal.comment,
            addr: newVal.addr || '',
            chinaid: '',
            realname: '',
            phone: '',
            sex: 1,
            relation: ''
          }
          this.see = false;
        }
      },
      deep: true,
      immediate: true,
    }
  },
  created() {

  },
  methods: {
    AddCg(val) {
      if (this.form.dwell_addr.length == 0) {
        this.form.dwell_addr = this.form.addr
      }
    },
    getSex(UUserCard) {
      this.form.sex = parseInt(UUserCard.substr(16, 1)) % 2 == 1 ? 1 : 2
    },
    isEdit(Arr, val) {
      if (Arr) {
        let bool = Arr.filter(ele => {
          return val.split(",").indexOf(ele.field) >= 0
        }).length > 0 ? true : false;
        return bool
      }
    },
    citysCg(val) {
      if (this.form.dwell.length == 0) {

        this.form.dwell = val
      }
    },
    confirm(id) {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          form.province = form.citys[0];
          form.city = form.citys[1];
          form.area = form.citys[2];
          if (form.dwell.length > 0) {
            form.dwell_province = form.dwell[0];
            form.dwell_city = form.dwell[1];
            form.dwell_area = form.dwell[2];
            delete form.dwell
          }
          delete form.citys
          form.debtor_id = this.$route.params.id
          if (id) {
            form.id = id
          }
          debtorOther(id, form).then(e => {
            this.$message.success({ content: id ? '已提交修改申请' : '新增成功', key: 'updatable' });
            // this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
            // this.reset()

            window.history.go(0)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      this.$refs.forms.resetFields();
      this.$store.dispatch('openkey', { key: 'Other', by: false })
    },
  },
}
</script>
<style lang="less">
.otherform .yellow {
  border: 1px solid #ff9800 !important;
  opacity: 1;
  color: #ccc;
  /* border: 0 none; */
  background: none;
}
</style>